import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPackageCategories = packageCategories => ({
  type: actionTypes.SET_PACKAGE_CATEGORIES,
  payload: packageCategories
})
